import {createInvoker}        from '@ali/xcore/invoker.async';
import reqwest                from '../middlewares/reqwest';

let Invoker = createInvoker('ajax')
  .use(reqwest);

export default Invoker;



// WEBPACK FOOTER //
// ./src/invokers/ajax.js